import { fromJS } from 'immutable';
import { handleActions } from 'redux-actions';
import {
  CHARTIQ_DRAW_CHANGE_LINE_PARAMS,
  CHARTIQ_DRAW_CHANGE_TOOL,
  CHARTIQ_DRAW_SET_FILL_COLOR,
  CHARTIQ_DRAW_SET_FILL_STYLE,
  CHARTIQ_DRAW_SET_FONT_FAMILY,
  CHARTIQ_DRAW_SET_FONT_SIZE,
  CHARTIQ_DRAW_SET_FONT_STYLE,
  CHARTIQ_DRAW_SET_LINE_COLOR,
  CHARTIQ_DRAW_TOGGLE_DRAWING,
} from './constants';

const CIQ = (window as any).CIQ;
const drawingTools = CIQ.Drawing.getDrawingToolList({ retracement: true });
const toolsArray = Object.keys(drawingTools).map((key) => drawingTools[key]);

const initialState = fromJS({
  color: null,
  fill: null,
  fontFamily: 'Helvetica',
  fontOptions: null,
  fontSize: '13px',
  fontStyle: {
      bold: false,
      italic: false,
  },
  line: null,
  linePattern: null,
  lineWidth: null,
  selectedTool: null,
  showDrawingToolbar: false,
  tools: toolsArray.sort(),
});

export default handleActions({
  [CHARTIQ_DRAW_TOGGLE_DRAWING]: (state: any) => {
    const elem = document.getElementById('chartContainer');
    const flip = !state.get('showDrawingToolbar');
    if (!elem) { return state }

    if (flip) {
      elem.classList.add('toolbarOn');
    } else {
      elem.classList.remove('toolbarOn');
    }

    return state.set('showDrawingToolbar', flip);
  },
  [CHARTIQ_DRAW_SET_FONT_FAMILY]: (state: any, action: any) => state.set('fontFamily', action.payload.family),
  [CHARTIQ_DRAW_SET_FONT_SIZE]: (state: any, action: any) => state.set('fontSize', action.payload.size + 'px'),
  [CHARTIQ_DRAW_SET_FONT_STYLE]: (state: any, action: any) => {
    const newStyle = state.get('fontStyle').toJS();
    newStyle[action.payload.type] = !newStyle[action.payload.type];
    return state
    .set('fontStyle', fromJS(newStyle));
  },
  [CHARTIQ_DRAW_SET_LINE_COLOR]: (state: any, action: any) => state.set('line', CIQ.hexToRgba('#' + action.payload.color)),
  [CHARTIQ_DRAW_SET_FILL_STYLE]: (state: any, action: any) => state.set('fill', action.payload.style),
  [CHARTIQ_DRAW_SET_FILL_COLOR]: (state: any, action: any) => state.set('fill', CIQ.hexToRgba('#' + action.payload.color)),
  [CHARTIQ_DRAW_CHANGE_LINE_PARAMS]: (state: any, action: any) => state
    .set('lineWidth', action.payload.weight)
    .set('linePattern', action.payload.pattern),
  [CHARTIQ_DRAW_CHANGE_TOOL]: (state: any, { payload }: any) => {
    const { tools, toolParams } = payload;
    let retState = state
    .set('selectedTool', tools.replace(/\w\S*/g, (txt: string) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()));

    if (toolParams) {
      retState = retState
      .set('fill', toolParams.fillColor)
      .set('line', toolParams.color)
      .set('lineWidth', toolParams.lineWidth)
      .set('linePattern', toolParams.pattern);
      const { font } = toolParams;
      if (font) {
        retState = retState
        .set('fontOptions', font)
        .set('fontSize', font.size)
        .set('fontFamily', font.family);
      }
    }
    return retState;
  },
}, initialState);
